import moment from 'moment';

const TablesContainerMeasure = ({ paginatedItems, selectedItems, handleSelectAll, handleSelectItem, t, measures, device }) => {
    // build a quick lookup for filling values keyed by timestamp for the current device
    let fillingMap = null;
    if (measures && device && measures[device] && Array.isArray(measures[device].filling)) {
        fillingMap = new Map(measures[device].filling.map((it) => [it[0], it[1]]));
    }
    return (
        <div className="row">
            <div className="col-12">
                <table className="table table-striped">
                    <thead>
                        <tr>
                            <th>
                                <input
                                    type="checkbox"
                                    checked={selectedItems.length === paginatedItems.length && paginatedItems.length > 0}
                                    onChange={handleSelectAll}
                                />
                            </th>
                            <th>{t("Fecha")}</th>
                            <th>{t("Llenado")}</th>
                            <th>{t("Medida")}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {paginatedItems.length > 0 ? (
                            // El backend ya devuelve las medidas ordenadas por fecha descendente.
                            paginatedItems.map((item) => (
                                <tr key={item[0]}>
                                    <td>
                                        <input
                                            type="checkbox"
                                            checked={selectedItems.includes(item)}
                                            onChange={() => handleSelectItem(item)}
                                        />
                                    </td>
                                    <td>{moment(item[0] * 1000).format('DD-MM-YYYY HH:mm')}</td>
                                    <td>{fillingMap ? (fillingMap.get(item[0]) ?? '-') : '-'}</td>
                                    <td>{item[1]}</td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="4" className="text-center">
                                    {t("common.noData")}
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default TablesContainerMeasure;